<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

// Estados do relatorio do funil (carregando, erro e vazio), fora do
// KanbanReports.vue: o arquivo tinha 3 mil linhas e as cores daqui eram hex e
// classes fixas (blue-500, red-300, woot-500) que nao seguiam o tema claro.

defineProps({
  state: {
    type: String,
    required: true,
    validator: value => ['loading', 'error', 'empty'].includes(value),
  },
  // Vazio com filtro de pessoa diz outra coisa do que vazio no funil inteiro.
  agentFiltered: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['retry']);

const { t } = useI18n();
</script>

<template>
  <div
    v-if="state === 'loading'"
    role="status"
    class="flex items-center justify-center gap-3 py-12 text-n-slate-11"
    data-testid="kanban-report-loading"
  >
    <span
      class="i-ph-circle-notch size-6 animate-spin text-n-brand"
      aria-hidden="true"
    />
    <span>{{ t('REPORTS.STATES.LOADING') }}</span>
  </div>

  <div
    v-else-if="state === 'error'"
    role="alert"
    class="flex flex-wrap items-center justify-between gap-3 rounded-xl bg-n-ruby-2 px-3.5 py-3 text-sm text-n-ruby-11"
    data-testid="kanban-report-error"
  >
    <span class="flex min-w-0 flex-col gap-0.5">
      <strong class="font-semibold">{{ t('REPORTS.STATES.ERROR_TITLE') }}</strong>
      <span>{{ t('REPORTS.STATES.ERROR_DESCRIPTION') }}</span>
    </span>
    <Button
      variant="outline"
      color="ruby"
      size="sm"
      class="min-h-11"
      icon="i-ph-arrow-clockwise"
      :label="t('REPORTS.STATES.RETRY')"
      data-testid="kanban-report-retry"
      @click="emit('retry')"
    />
  </div>

  <div
    v-else
    class="flex flex-col items-center justify-center gap-2 py-16 text-center"
    data-testid="kanban-report-empty"
  >
    <span class="i-ph-tray size-14 text-n-slate-10" aria-hidden="true" />
    <h3 class="m-0 text-xl font-medium text-n-slate-12">
      {{ t('REPORTS.STATES.EMPTY_TITLE') }}
    </h3>
    <p class="m-0 text-n-slate-11">
      {{
        agentFiltered
          ? t('REPORTS.STATES.EMPTY_AGENT_DESCRIPTION')
          : t('REPORTS.STATES.EMPTY_BOARD_DESCRIPTION')
      }}
    </p>
    <p class="m-0 text-sm text-n-slate-11">
      {{
        agentFiltered
          ? t('REPORTS.STATES.EMPTY_AGENT_HINT')
          : t('REPORTS.STATES.EMPTY_BOARD_HINT')
      }}
    </p>
  </div>
</template>
